import { Directive, ElementRef, Renderer2, Input, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
var StickyPosition;
(function (StickyPosition) {
    StickyPosition["TOP"] = "top";
    StickyPosition["BOTTOM"] = "bottom";
})(StickyPosition || (StickyPosition = {}));
class AwStickyDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.stickyClass = 'aw-sticky';
        this.stickyPosition = StickyPosition.BOTTOM;
        this.stickyEl = this.elementRef.nativeElement;
    }
    get stickyBoundaryContainer() {
        return this._boundary || this.wrapper;
    }
    set stickyBoundaryContainer(selector) {
        if (typeof selector === 'string') {
            this._boundary = document.querySelector(selector);
        }
        else {
            this._boundary = selector;
        }
    }
    get isSticky() {
        if (this.isStickyTop) {
            return this.wrapper.getBoundingClientRect().top < 0;
        }
        return this.wrapper.getBoundingClientRect().bottom > window.innerHeight;
    }
    get isStickyTop() {
        return this.stickyPosition === StickyPosition.TOP;
    }
    onResize() {
        this.checkStickyPosition();
    }
    ngAfterContentInit() {
        this.createWrapper();
        this.checkStickyPosition();
        window.addEventListener('scroll', this.checkStickyPosition.bind(this), true);
    }
    ngOnDestroy() {
        window.removeEventListener('scroll', this.checkStickyPosition, true);
    }
    createWrapper() {
        this.wrapper = this.renderer.createElement('div');
        this.wrapper.classList.add('aw-sticky-wrapper');
        this.renderer.insertBefore(this.stickyEl.parentNode, this.wrapper, this.stickyEl);
        this.renderer.appendChild(this.wrapper, this.stickyEl);
    }
    setSizes() {
        this.renderer.setStyle(this.stickyEl, 'left', `${this.stickyBoundaryContainer.getBoundingClientRect().left}px`);
        this.renderer.setStyle(this.stickyEl, 'width', `${this.stickyBoundaryContainer.getBoundingClientRect().width}px`);
        this.renderer.setStyle(this.wrapper, 'height', `${this.stickyEl.getBoundingClientRect().height}px`);
    }
    removeSizes() {
        this.renderer.removeStyle(this.stickyEl, 'width');
        this.renderer.removeStyle(this.stickyEl, 'left');
        this.renderer.removeStyle(this.stickyEl, 'width');
    }
    checkStickyPosition() {
        if (this.isSticky) {
            this.stick();
        }
        else {
            this.unstick();
        }
    }
    stick() {
        this.renderer.addClass(this.stickyEl, this.stickyClass);
        this.renderer.setStyle(this.stickyEl, 'position', 'fixed');
        this.renderer.setStyle(this.stickyEl, this.isStickyTop ? 'top' : 'bottom', '0px');
        this.setSizes();
    }
    unstick() {
        this.renderer.removeClass(this.stickyEl, this.stickyClass);
        this.renderer.removeStyle(this.stickyEl, 'position');
        this.renderer.removeStyle(this.stickyEl, this.isStickyTop ? 'top' : 'bottom');
        this.removeSizes();
    }
}
AwStickyDirective.ɵfac = function AwStickyDirective_Factory(t) { return new (t || AwStickyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
AwStickyDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwStickyDirective, selectors: [["", "aw-sticky", ""]], hostBindings: function AwStickyDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function AwStickyDirective_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { stickyClass: ["aw-sticky-class", "stickyClass"], stickyPosition: ["aw-sticky-position", "stickyPosition"], stickyBoundaryContainer: ["aw-sticky-boundary-container", "stickyBoundaryContainer"] } });
AwStickyDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
AwStickyDirective.propDecorators = {
    stickyClass: [{ type: Input, args: ['aw-sticky-class',] }],
    stickyPosition: [{ type: Input, args: ['aw-sticky-position',] }],
    stickyBoundaryContainer: [{ type: Input, args: ['aw-sticky-boundary-container',] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwStickyDirective, [{
        type: Directive,
        args: [{ selector: '[aw-sticky]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { stickyClass: [{
            type: Input,
            args: ['aw-sticky-class']
        }], stickyPosition: [{
            type: Input,
            args: ['aw-sticky-position']
        }], stickyBoundaryContainer: [{
            type: Input,
            args: ['aw-sticky-boundary-container']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }] }); })();

class AwStickyModule {
}
AwStickyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwStickyModule });
AwStickyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwStickyModule_Factory(t) { return new (t || AwStickyModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwStickyModule, { declarations: function () { return [AwStickyDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AwStickyDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwStickyModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AwStickyDirective
                ],
                exports: [
                    AwStickyDirective
                ]
            }]
    }], null, null); })();

export { AwStickyDirective, AwStickyModule, StickyPosition };

//# sourceMappingURL=aw-ads-components-src-directives-aw-sticky.js.map